import { DocumentationLegacyGroupBehavior } from "../../model/enums/SDKDocumentationLegacyGroupBehavior";
import { DocumentationLegacyPageBlockType } from "../../model/enums/SDKDocumentationLegacyPageBlockType";
import { MarkdownTransformBlock, } from "./SDKToolsMarkdownTransformBlock";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
/** Output markdown mode. Commonmark and GitHub is currently supported */
export var MarkdownTransformType;
(function (MarkdownTransformType) {
    MarkdownTransformType["commonmark"] = "commonmark";
    MarkdownTransformType["github"] = "github";
})(MarkdownTransformType || (MarkdownTransformType = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Search Instance
/** Markdown transformers */
export class MarkdownTransform {
    // --- Constructor
    constructor(type, instance, designSystemId, workspaceId, versionId, config = { urlType: "relative-to-markdown" }) {
        /** Creates flattened structure of the blocks, even from the contained blocks, so it is easier to iterate through them */
        this.flattenedBlocksOfPage = (page) => {
            let { blocks } = page;
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            for (const block of page.blocks) {
                // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                blocks = blocks.concat(this.flattenedBlocksOfBlock(block));
            }
            // @ts-expect-error TS(2322): Type 'DocumentationLegacyPageBlock[] | undefined' ... Remove this comment to see the full error message
            return blocks;
        };
        /** Flattens one leaf of blocks */
        this.flattenedBlocksOfBlock = (block) => {
            // For containers, we will ignore all their children - they are generated separately by the behavior of the container itself (tables, tabs etc.)
            if (this.isContainer(block.type)) {
                return [];
            }
            // @ts-expect-error TS(2322): Type 'DocumentationLegacyPageBlock[] | undefined' ... Remove this comment to see the full error message
            let subblocks = block.children;
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            for (const subblock of block.children) {
                subblocks = subblocks.concat(this.flattenedBlocksOfBlock(subblock));
            }
            return subblocks;
        };
        this.conversionType = type;
        if (type === MarkdownTransformType.github) {
            console.log("Note: GitHub mode of markdown is currently in development and is not yet fully supported");
        }
        this.blockTransformer = new MarkdownTransformBlock(type, instance, designSystemId, workspaceId, versionId, config);
    }
    // --- Conversion
    /** Converts entire definition of the page, including its metadata like title and description, to markdown */
    async convertPageToMarkdown(page) {
        var _a, _b;
        // Initialize the block transformer to cache documentation representation
        await this.blockTransformer.initialize();
        const blocks = this.flattenedBlocksOfPage(page);
        const pageContent = [];
        for (const block of blocks) {
            // TODO:fix-sdk-eslint
            // eslint-disable-next-line no-await-in-loop
            const blockContent = await this.blockTransformer.convertBlockToMarkdown(block, page);
            if (blockContent) {
                pageContent.push(blockContent);
            }
        }
        // Check if this page is part of a tab group
        const isTabPage = page.parent &&
            page.parent.groupBehavior === DocumentationLegacyGroupBehavior.tabs;
        // Build breadcrumb-style title
        const title = isTabPage
            ? `# ${page.parent.title} › ${page.title}\n\n`
            : `# ${page.title}\n\n`;
        // Use parent tab description if available, otherwise use page description
        let descriptionText = "";
        if (isTabPage && ((_b = (_a = page.parent.configuration) === null || _a === void 0 ? void 0 : _a.header) === null || _b === void 0 ? void 0 : _b.description)) {
            descriptionText = page.parent.configuration.header.description;
        }
        else if (page.configuration.header.description) {
            descriptionText = page.configuration.header.description;
        }
        const description = descriptionText ? `${descriptionText}\n\n` : "";
        const heading = `${title}${description}---\n\n`;
        const content = pageContent.join("\n\n");
        return `${heading}${content}`;
    }
    isContainer(blockType) {
        return (blockType === DocumentationLegacyPageBlockType.table ||
            blockType === DocumentationLegacyPageBlockType.tableCell ||
            blockType === DocumentationLegacyPageBlockType.tableRow ||
            blockType === DocumentationLegacyPageBlockType.column ||
            blockType === DocumentationLegacyPageBlockType.columnItem ||
            blockType === DocumentationLegacyPageBlockType.tabs ||
            blockType === DocumentationLegacyPageBlockType.tabItem ||
            blockType === DocumentationLegacyPageBlockType.guidelines);
    }
}
